import { Injectable, SecurityContext, ViewContainerRef } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "src/modules/base/services/translate.service";
import { BaseService } from "src/modules/base/shared/services/base.service";
import set from 'lodash-es/set';
import { RolePermissionService } from "src/modules/base/shared/services/role-permission.service";
import { LoaderService } from "src/modules/base/services/loader.service";
import { HttpHeaders } from "@angular/common/http";
import { AlertsService } from "src/modules/base/services/alerts.service";
import * as CryptoJS from 'crypto-js';
@Injectable(
    { providedIn: 'root' }
)
export class AIService {

    public ALLOWED_COMPONENTS: string[] = ['textbox','dropdown','radio','checkbox','textarea','numberbox','daterangepicker',
      'timepicker','html-editor','rating',
      // 'score', 'editgrid', 'edit_grid', 'dynamic-table' — disabled, not needed for now. 
      'composite-array','searchselect','range','monthYearPicker',
      'single-choice-question','text-entry-question'
    ]
    public static SCAN_FILL = "scan_fill"
    public static VOICE_FILL = "voice_fill"
    public static ENABEL_AI = "enable_ai" 
    public static ASK_YOUR_DATA = "ask_your_data" 
    public static GRID_SUMMARY = "grid_summary" 
    public static CUSTOM_MIS = "custom_mis" 
    public static AI_SUMMARY = "ai_summary" 
    public static AI_REPORT = "ai_report" 
    public AI_DECORATOR_DEF:{};
    public AGETNT_LIST = new Set();
    public PROMPT_MASTER_LIST = {};
    public static INSTRUCTIONS_CODE: string[] =["GENERATE_INSIGHT_PIPELINE","GENERATE_REPORT_CODE","GENERATE_REPORT_SCHEMA"];
    constructor(
        public translateService:TranslateService,
        public loader:LoaderService,
        public alertService:AlertsService,
        public rolePermissionService:RolePermissionService,
        public baseService:BaseService,
        public sanitizer:DomSanitizer)
        {
    }

    mergeDotNotationLodash(source: Record<string, any>, target: Record<string, any>) {
        for (const key in source) {
            set(target, key, source[key]);
        }
      }

    checkFeatureEnabledinJson(config,feature){
        if(config.feature != undefined){
            if(Array.isArray(config.feature) && config.feature.length>0){
                if(config.feature.indexOf(feature)>-1){
                    return true;
                }
            }else{
                if(config.feature == feature){
                    return true;
                }
            }
        }
        return false;
    }

    retryCheckAsyncTask(
      taskId: string,
      processFn: (res: any) => void,
      retryDelayMs = 15000,   // wait time between retries
      maxRetries = 8,        // total attempts
      onProgress?: (res: any) => void   // called with every PROCESSING / IN-QUEUE poll result
    ) {
      let attempt = 0;
    
      const tryCheck = () => {
        attempt++;
    
        this.checkAyncTaskDone(taskId, (asyncRes) => {
          if (!asyncRes) {
            this.alertService.error("ERROR IN AI");
            return;
          }
    
          if (asyncRes.status === "SUCCESS") {
            processFn(asyncRes);
            return;
          }
    
          if (asyncRes.status === "FAILED") {
            processFn(false);
            this.alertService.error("ERROR IN AI");
            return;
          }
    
          if (asyncRes.status === "PROCESSING" || asyncRes.status === "IN-QUEUE") {
            if (onProgress) {
              onProgress(asyncRes);
            }
            if (attempt >= maxRetries) {
              processFn(false);
              this.alertService.error("AI task timed out");
              return;
            }
    
            setTimeout(() => {
              tryCheck();
            }, retryDelayMs);
          }
        });
      };
    
      tryCheck();
    }

    
    checkAyncTaskDone(task_id,callback){
      var datasource = {
        resource: "ai_async_tasks",
        application: "aiml-gateway"
      }
      this.baseService.getById(task_id,datasource.resource,datasource.application).subscribe(
        (data: any) => {
              if (data) {
                callback(data)
              } else {
                callback({"status":"PROCESSING"})//simulate PROCESSING because async task is not inserted yet
               
              }
          }, error => {
              console.error(error);
              callback(false)
          }
      )
    }

    getDatasourceByAiConfig(uiConfig,config){
        var dynamicKey = false;
        var promtCode = false;
        var templateName = false;
        var llmName = false;
        var feature ="";
        if(config.prompt_config_current != undefined){
            promtCode = config.prompt_config_current.prompt_code;
            feature = config.prompt_config_current.ai_feature_code;
            templateName = config.prompt_config_current.template_name;
            llmName = config.prompt_config_current.llm_name;
        }else{
            if(config.full_prompt_code != undefined){
                promtCode = config.full_prompt_code;
            }else{
                promtCode = config.prompt_code;
                dynamicKey = (uiConfig.dynamic_key != undefined ? uiConfig.dynamic_key:"*")
            }
            feature = config.feature;
            if(feature && feature.indexOf(",")>-1){
                feature = feature.replace(",","#");
            }
        }
        
        
        var args = "feature:"+feature+",prompt_code:"+promtCode;
        if(dynamicKey){
            args = args+",dynamic_key:"+dynamicKey;
        }
        if(templateName){
            args = args+",templateName:"+templateName;
        }
        if(uiConfig.args != undefined && uiConfig.args != ""){
            args = args+","+uiConfig.args;
        }
        if(uiConfig.final_url != undefined && uiConfig.final_url != ""){
            args = args+",final_url:"+btoa(uiConfig.final_url);
        }
        if(llmName){
            args = args+",llm:"+llmName;
        }
        var datasource = {
            query_id: "ai_query",
            args :args ,
            filter : uiConfig.filter,
            resource: "ai_response",
            application: "aiml-gateway",
            feature:feature,
            prompt_code:promtCode,
            dynamic_key:dynamicKey,
        }
        return datasource;
    }
    async getFormSchema(fieldGroup,resource_config){
        var json:any ={};
        var formConfig = resource_config?.ai?.form
        if(fieldGroup && fieldGroup.blocks != undefined){
            for (let index = 0; index < fieldGroup.blocks.length; index++) {
                const singleBlock = fieldGroup.blocks[index];
                if(singleBlock && singleBlock.fields != undefined && Array.isArray(singleBlock.fields) && singleBlock.fields.length>0){
                    for (let index = 0; index < singleBlock.fields.length; index++) {
                        const singleField = singleBlock.fields[index];
                        if(singleField && singleField.blocks != undefined && Array.isArray(singleField.blocks) && singleField.blocks.length>0){
                            resourceDef = await  this.getFormSchema(singleField,resource_config);
                            if(resourceDef){
                                this.mergeDotNotationLodash(resourceDef,json);
                            }
                        }else if(singleField.type == "COMPOSITE-ARRAY" || singleField.type == "COMPOSITE-OBJECT"){
                            
                            var resourceDef:any={};
                            if(singleField.type == "COMPOSITE-OBJECT"){
                                resourceDef = await this.baseService.getResourceDefSync(singleField.component);
                                if(resourceDef){
                                    json[singleField.name] = await this.getFormSchema(resourceDef.form,resource_config);
                                }
                            }else{
                                resourceDef = await this.baseService.getResourceDefSync(singleField.resource);
                                if(resourceDef){
                                    json[singleField.name] = [await this.getFormSchema(resourceDef.form,resource_config)];
                                }
                            }
                            
                            console.log(resourceDef)
                        /* editgrid/edit_grid support intentionally disabled for now — not needed.
                        }else if(singleField.component == "edit_grid" || singleField.component == "editgrid"){
                            if(singleField.resource != undefined){
                                var editGridResourceDef:any = await this.baseService.getResourceDefSync(singleField.resource);
                                if(editGridResourceDef){
                                    json[singleField.name] = [await this.getFormSchema(editGridResourceDef.form,resource_config)];
                                }
                            }
                        */
                        }else{
                            if(singleField.name != undefined && singleField.component != undefined && this.ALLOWED_COMPONENTS.indexOf(singleField.component)>-1){
                                if(formConfig.exclude != undefined && Array.isArray(formConfig.exclude) && formConfig.exclude.indexOf(singleField['name'])>-1){
                                    continue;
                                }
                                json[singleField.name] = {};
                                json[singleField.name]['order'] = singleField['order'] || 0;
                                json[singleField.name]['type'] = singleField['type'] || "String";
                                json[singleField.name]['name'] = singleField['name'];
                                json[singleField.name]['required'] = (singleField['required'] != undefined)?singleField['required']:false;
                                json[singleField.name]['label'] = await this.translateService.translateSync(singleField['label']);
                            }
                        }
                        
                    }
                }
            }
        }

        return json;
    }

    initDecorator(decorator: any, route: any, injector?) {
        var decoratorClass: any = false;
        if (this.AI_DECORATOR_DEF!= undefined && this.AI_DECORATOR_DEF[decorator] != undefined) {
            console.info("decorator found======>", decorator);
            try {
                decoratorClass = new this.AI_DECORATOR_DEF[decorator](route, decorator, injector);
                decoratorClass.init();
            } catch (e) {
                decoratorClass = false;
                console.error("decorator load error ==>", e);
            }
        } else {
            console.error("decorator not found");
        }
        return decoratorClass;
    }

    checkIfAIAvailable(resouceDef,ai_feature,callback,checkEditing=true){
        
        const datasource:any = {
            "application":"aiml-gateway",
            "args":"dummy:dummy",
            "resource":"ai_prompt_master",
            "query_id": "GET_AVAILABLE_AI_FEATURES",
            "filter":"resource.id:"+resouceDef.resource,
            "projectionKeys":"id,is_async,llm_name,model,output_mode,resource,response_type,schema,template_name,ai_agent,attachment,ai_feature_code,ai_feature_value,prompt_code"
        }//todo replace ocr to resource
        if(ai_feature){
            if(Array.isArray(ai_feature)){
                datasource["filter"] += ",ai_feature_code:"+ai_feature.join("#")
            }else{
                datasource["filter"] += ",ai_feature_code:"+ai_feature
            }
            
        }

        const cacheKey = CryptoJS.MD5(JSON.stringify(datasource)).toString();
        const isAvailable = this.rolePermissionService.checkIfEnabled(AIService.ENABEL_AI)
        if (!isAvailable) {
            //AI not enabled no need to make network request
            this.checkIfEditingAvaialable(resouceDef,false ,false,checkEditing,callback);
        }
        else if(this.PROMPT_MASTER_LIST[cacheKey] != undefined){
            this.checkIfEditingAvaialable(resouceDef,JSON.parse(JSON.stringify(this.PROMPT_MASTER_LIST[cacheKey])) ,false,checkEditing,callback);
        }else{
          var makeArgs = {
            args: datasource.args,
            filter: datasource.filter,
            projectionKeys: datasource.projectionKeys
          }
          this.baseService.getData(makeArgs, "", datasource.resource, datasource.application, datasource.query_id).subscribe(
           // this.baseService.getByDataSource(datasource).subscribe(
            (data: any) => {
                if (data.erroCode == -1) {
                this.checkIfEditingAvaialable(resouceDef,false,cacheKey,checkEditing,callback);
                } else {
                if (data.resource != undefined && data.resource.length > 0) {
                    const currentData = data.resource;
                    for (let index = 0; index < currentData.length; index++) {
                      const element = currentData[index];
                      if(Array.isArray(element.resource)){
                        element.resource = resouceDef.resource
                      }                      
                    }
                    this.checkIfEditingAvaialable(resouceDef,currentData,cacheKey,checkEditing,callback);
                }else{
                    this.checkIfEditingAvaialable(resouceDef,false,cacheKey,checkEditing,callback);
                }
                }
            }, error => {
                this.checkIfEditingAvaialable(resouceDef,false,cacheKey,checkEditing,callback);
            }
            )
        }
        
      
        
    }

    checkIfEditingAvaialable(resouceDef,data,cacheKey,checkEditing=true,callback){
        if(cacheKey){
            this.PROMPT_MASTER_LIST[cacheKey] = JSON.parse(JSON.stringify(data));
        }
        if(!checkEditing){
            callback(data);
            return;
        }
        
        const editingAvaialble = this.rolePermissionService.checkAccessPermission("AI_EDIT","ai_response","aiml-gateway");
        const isAvailable = this.rolePermissionService.checkIfEnabled(AIService.ENABEL_AI)
        if(isAvailable){
            if(resouceDef.config == undefined){
                resouceDef.config = {};
            }
            if(resouceDef.config.ai == undefined){
                resouceDef.config.ai = {};
            }
            if(resouceDef.config.ai.grid == undefined){
                resouceDef.config.ai.grid = {};
            }            
        }

        if(isAvailable && editingAvaialble){
            resouceDef.config.ai.grid.editing = true;
        }


        if(isAvailable && data){
            resouceDef.config.ai.grid.prompt_config = data;
        }
        if(!isAvailable && resouceDef.config != undefined){
            delete resouceDef.config.ai;
        }

        callback(resouceDef)
        
    }

    getPromptSchema(schema,callback){
        var datasource:any = {
            query_id: "get_schema",
            args :"schema:"+schema ,
            resource: "ai_response",
            application: "aiml-gateway"
        } 
        this.baseService.getByDataSource(datasource).subscribe(
            (data) => {
              this.loader.hideSpinner();
              if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                  callback(data.resource)                 
              }
              else {
                  callback(false)
                  this.alertService.error(data.message)
              }
            },
            error=>{            
              this.loader.hideSpinner();
              console.log(error);
              this.alertService.error(error)
              callback(false)
            })
    }

    getPresignUrl(uhId,encounterId,seq,callback){
        var datasource:any = {
            query_id: "get_presign_url",
            args :"uhId:"+uhId+",encounterId:"+encounterId+",seq:"+seq,
            resource: "ai_response",
            application: "aiml-gateway"
        } 
        this.baseService.getByDataSource(datasource).subscribe(
            (data) => {
              this.loader.hideSpinner();
              if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                  callback(data.resource)                 
              }
              else {
                  callback(false)
                  this.alertService.error(data.message)
              }
            },
            error=>{            
              this.loader.hideSpinner();
              console.log(error);
              this.alertService.error(error)
              callback(false)
            })
    }
    loadAgents() {
        var datasource:any = {
            query_id: "GET_ALL",
            filter :"userId:"+this.baseService.authenticationService.getCurrentUser().user_id,
            resource: "user_ai_agent_mapping",
            application: "account-management"
        } 
        this.baseService.getByDataSource(datasource).subscribe(
        (data) => {
            if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                var list = []
                for (let index = 0; index < data.resource.length; index++) {
                    list.push(data.resource[index].ai_agent_code)                    
                }
                this.AGETNT_LIST = new Set(list);
                console.log(this.AGETNT_LIST)
            }
            else {
                this.AGETNT_LIST = new Set()  
            }
        },
        error=>{
            this.AGETNT_LIST = new Set()   
        })
    }
    getPromptResponse(prompt_code,feature,prompt,filter,callback){
            this.loader.showSpinner();
           
            var aiResponse:any = {};
            var datasource:any = {
                query_id: "ai_query",
                args :"feature:"+feature ,
                resource: "ai_response",
                application: "aiml-gateway",
                feature:feature
            }          
           
            aiResponse.input = btoa(prompt);
            aiResponse.prompt_code = prompt_code;
            aiResponse.filter = filter;
            datasource.headers = {"headers": new HttpHeaders()
            .set('timeout', "300000")}
            this.baseService.action(aiResponse,"AI_FILL",datasource.application,datasource.resource,undefined,datasource.headers).subscribe(
              (data) => {
                this.loader.hideSpinner();
                if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                  var message = JSON.parse(atob(data.resource[0].message))
                  callback(message)   
                }
                else {
                    callback(false)
                  this.alertService.error(data.message)
                }
              },
              error=>{
              
                this.loader.hideSpinner();
                console.log(error);
                this.alertService.error(error)
                callback(false)
              })
          }

          getTransribe(object_key,callback){
           
            var aiResponse:any = {
                "dynamic_key":object_key,
                "prompt_code" :"AI_MEDICAL_TRANSCRIBE"
            };
            var datasource:any = {
                query_id: "AI_TRANSCRIBE",                
                resource: "ai_response",
                application: "aiml-gateway"
            }          
            datasource.headers = {"headers": new HttpHeaders()
            .set('timeout', "300000")}
            this.baseService.action(aiResponse,"AI_TRANSCRIBE",datasource.application,datasource.resource,undefined,datasource.headers).subscribe(
              (data) => {
                if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                  var message = data.resource[0].message
                  callback(message)   
                }
                else {
                    callback(false)
                  this.alertService.error(data.message)
                }
              },
              error=>{
                console.log(error);
                this.alertService.error(error)
                callback(false)
              })
          }

    processGrnInvoice(documentId: string, promptCode: string, currentItems: any[], callback) {
        var aiResponse: any = {
            prompt_code: promptCode,
            type: "is_async:true"
        };
        // PromptService.py's generic dispatcher resolves the uploaded file via
        // filter.documentId (S3Manager.downloadByDocumentID) — not dynamic_key.
        var filterParts = ["documentId:" + documentId];
        if (currentItems && currentItems.length > 0) {
            filterParts.push("config_data:" + btoa(JSON.stringify(currentItems)));
        }
        aiResponse.filter = filterParts.join(",");
        var datasource: any = {
            resource: "ai_response",
            application: "aiml-gateway"
        };
        datasource.headers = { "headers": new HttpHeaders().set('timeout', "300000") };
        this.baseService.action(aiResponse, "AI_FILL", datasource.application, datasource.resource, undefined, datasource.headers).subscribe(
            (data) => {
                if (data.errCode == 0 && data.resource != undefined && data.resource.length > 0) {
                    callback(data.resource[0].id);
                } else {
                    callback(false);
                    this.alertService.error(data.message);
                }
            },
            error => {
                console.log(error);
                this.alertService.error(error);
                callback(false);
            });
    }

    getPromptInstructions(callback){
            this.loader.showSpinner();
            var datasource:any = {
                query_id: "GET_PAGE",
                resource: "ai_prompt_master",
                application: "aiml-gateway",
                filter:"prompt_code:"+AIService.INSTRUCTIONS_CODE.join("#")
            }
            this.baseService.getByDataSource(datasource).subscribe(
              (data) => {
                this.loader.hideSpinner();
                if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                    console.log(data.resource)
                    var instructions={}
                    for (let index = 0; index < data.resource.length; index++) {
                        const element = data.resource[index];
                        instructions[element.prompt_code] = element.prompt
                    }
                    callback(instructions)   
                }
                else {
                    callback(false)
                    this.alertService.error(data.message)
                }
              },
              error=>{
              
                this.loader.hideSpinner();
                console.log(error);
                this.alertService.error(error)
                callback(false)
              })
    }

    initAiSummary(config,data,application=false){
        if (config.resourceDef?.config?.ai != undefined && (config.resourceDef?.config?.ai?.grid != undefined || config.resourceDef?.config?.ai?.banner != undefined)) {
            data.gridConfig = config.resourceDef?.config?.ai?.grid || config.resourceDef?.config?.ai?.banner;
            data.summaryType = config.resourceDef?.config?.ai?.banner != undefined ? "banner" : "grid";
            data.label = data.gridConfig.label

            var isAvailable = this.rolePermissionService.checkIfEnabled(AIService.ENABEL_AI)
            if (isAvailable) {
                var featureFound = false;
                if (data.gridConfig.prompt_config != undefined && data.gridConfig.prompt_config && Array.isArray(data.gridConfig.prompt_config) && data.gridConfig.prompt_config.length > 0) {
                    for (let index = 0; index < data.gridConfig.prompt_config.length; index++) {
                        const element = data.gridConfig.prompt_config[index];
                        if(element.ai_feature_code == AIService.ASK_YOUR_DATA){
                            element.isFeatureAvailable = this.checkIfFeatureAvailable({ai_agent:element.ai_agent,feature:element.ai_feature_code, resource:"requested_downloads"})
                            if (element.isFeatureAvailable) {
                                featureFound = true;
                            } 
                        }else{
                            element.isFeatureAvailable = this.checkIfFeatureAvailable({ai_agent:element.ai_agent,feature:element.ai_feature_code, resource:config.resourceDef?.resource,application:application})
                            if (element.isFeatureAvailable) {
                                featureFound = true;
                            } 
                        }
                        
                    }
                    data.isAvailable = featureFound
                } else if (data.gridConfig.feature != undefined) {
                    data.isAvailable = true
                }

            }
            if (data.gridConfig.editing != undefined && data.gridConfig.editing) {
                data.editingAvailable = true;
            }
        }
    }

    checkIfFeatureAvailable(config){
        var feature = config.feature;
        var resource = config.resource;
        var aiAgent = config.ai_agent;
        if(Array.isArray(aiAgent) && aiAgent.length>0){
            var aiAgentArray=[]
            for (let index = 0; index < aiAgent.length; index++) {
                aiAgentArray.push(aiAgent[index].id)
            }
            if(aiAgentArray.some((element) => this.AGETNT_LIST.has(element))){
                var application = (config.application != undefined)?config.application:false
                var avaiable = this.rolePermissionService.checkAccessPermission(feature,resource,application) && this.rolePermissionService.checkIfEnabled(feature);
                 return avaiable;
            }else{
                return false;
            }           
        }else{
            return false;
        }
      
    }

    updateScript(resource,script,prompt,template_name,schemaId,callback){
            this.loader.showSpinner();
            var datasource:any = {
                resource: "ai_prompt_master",
                application: "aiml-gateway"
            }  
            var aiPrompt:any = {};
           
            aiPrompt.script = script;
            aiPrompt.resource = resource;
            aiPrompt.prompt = prompt;
            aiPrompt.template_name = template_name;
            aiPrompt.schema = schemaId;
            this.baseService.action(aiPrompt,"UPDATE_SCRIPT_BY_RESOURCE",datasource.application,datasource.resource,undefined,).subscribe(
              (data) => {
                this.loader.hideSpinner();
                if (data.errCode == 0 && data.resource != undefined && data.resource.length>0) {
                  callback(true)   
                }
                else {
                    callback(false)
                  this.alertService.error(data.message)
                }
              },
              error=>{
              
                this.loader.hideSpinner();
                console.log(error);
                this.alertService.error(error)
                callback(false)
              })
          }
    
          encodeToLatin1(str: string): string {
            return str.split('').map(char => {
              const code = char.charCodeAt(0);
              return code > 255 ? '?' : char;
            }).join('');
          }

    createComponent(comp:ViewContainerRef,kxselector: any, input,callback) {
    
        this.baseService.createComponent(kxselector, comp, (response) => {
        if (response) {  
                    
            if(input){
                for (const key in input) {
                    if (!(key in response.instance)) {
                      // if key not present, just set it
                      response.instance[key] = input[key];
                    } else {
                      if (Array.isArray(response.instance[key]) && Array.isArray(input[key])) {
                        // merge arrays, giving input priority (input first)
                        response.instance[key] = [...input[key], ...response.instance[key]];
                      } else if (
                        typeof response.instance[key] === "object" &&
                        typeof input[key] === "object"
                      ) {
                        // shallow merge objects, input has priority
                        response.instance[key] = { ...response.instance[key], ...input[key] };
                      } else {
                        // primitive → replace with input (input has priority)
                        response.instance[key] = input[key];
                      }
                    }
                  }
                  
            }
            if(response.changeDetectorRef != undefined){
                response.changeDetectorRef.detectChanges();
            }
            callback(response)
        }
        })
    }

    collectVisibleFields(root, options:any = {}, callback) {
        root = root ? $(root) : $('body');
        const customHandlers = options.customHandlers || {};
        const exclude = Array.isArray(options.exclude) ? options.exclude : [];
        const includeFilled = options.includeFilled === true; // default false
        const fields: { [key: string]: any } = {};
        let fieldIndex = 0;
        const processedNames = new Set();
      
        // --- helpers ---
        function isReallyVisible($el) {
          return $el.length && $el.is(':visible') && $el.css('visibility') !== 'hidden' && $el.closest('body').length;
        }
      
        function getLabel($el) {
          const override = $el.attr('data-field-label') || $el.attr('aria-label');
          if (override) return override;
          const id = $el.attr('id');
          if (id) {
            const $for = $(`label[for="${id}"]`);
            if ($for.length) return $for.first().text().trim();
          }
          const $closestLabel = $el.closest('label');
          if ($closestLabel.length) return $closestLabel.first().text().trim();
          const $containerLabel = $el.closest('.form-group, .form-row, .form-field').find('label').first();
          if ($containerLabel.length) return $containerLabel.text().trim();
          const placeholder = $el.attr('placeholder');
          if (placeholder) return placeholder;
          const name = $el.attr('name') || $el.attr('id');
          return name || '';
        }
      
        function makeKeyFromParts(name: string, id: string, label: string): string {
          if (name) return name;
          if (id) return id;
          if (label) {
            const k = String(label).trim().toLowerCase().replace(/\s+/g, '_').replace(/[^\w\-]/g, '');
            if (k) return k;
          }
          return `field_${fieldIndex++}`;
        }
      
        function normalizeType(tagName, inputType) {
          tagName = tagName.toLowerCase();
          if (tagName === 'textarea') return 'textarea';
          if (tagName === 'select') return 'select';
          if (tagName === 'input') {
            inputType = (inputType || 'text').toLowerCase();
            if (['checkbox','radio','text','email','number','date','tel','url','password','hidden','file','range','color','search','time','datetime-local'].includes(inputType)) {
              return inputType;
            }
            return 'text';
          }
          return 'custom';
        }
      
        function getSelectOptions($select) {
          const opts = [];
          $select.find('option').each(function () {
            const $o = $(this);
            opts.push({
              value: $o.val(),
              text: $o.text(),
              selected: $o.is(':selected')
            });
          });
          return opts;
        }
      
        // CKEditor4 leaves residual markup (a filler <br data-cke-filler> or empty
        // <p>&nbsp;</p>) even when untyped, which a raw .html().trim() would misread as
        // non-empty — strip it first so an untouched field isn't dropped as "already filled".
        function getCkEditableValue($el) {
          const html = ($el.html() || '').trim();
          if (!html) return '';
          const textOnly = html.replace(/<br[^>]*data-cke-filler[^>]*>/gi, '')
            .replace(/&nbsp;/gi, ' ')
            .replace(/<[^>]*>/g, '')
            .trim();
          return textOnly ? html : '';
        }
      
        function hasValueForElement($el, type) {
          try {
            if ($el.is('[contenteditable="true"]')) return $el.text().trim() !== '';
            if ($el.is('select')) {
              const v = $el.val();
              return (v !== null) && (Array.isArray(v) ? v.length > 0 : String(v) !== '');
            }
            if ($el.is('input[type="file"]')) {
              const files = $el[0].files;
              return files && files.length > 0;
            }
            const val = $el.val();
            return val !== undefined && val !== null && String(val).trim() !== '';
          } catch (e) {
            return false;
          }
        }
      
        // Insert field object into fields map (respect exclude & uniqueness)
        function insertField(field) {
          if (!field || typeof field !== 'object') return;
          if (Array.isArray(field)) {
            field.forEach(f => insertField(f));
            return;
          }
      
          const meta = (field.meta && typeof field.meta === 'object') ? field.meta : {};
          const key = makeKeyFromParts(meta.name, meta.id, field.label);
      
          // if excluded by name or id, skip
          if (exclude.includes(key) || exclude.includes(meta.name) || exclude.includes(meta.id)) return;
      
          // if field already has a non-empty value and includeFilled is false -> skip
          const val = field.value;
          // Booleans (checkbox) and numberbox are never "unanswered" the way an empty text
          // field is — always describe them (like radio/checkbox-group/dropdown below) so a
          // follow-up "change it" has something to act on. String(false) would otherwise
          // read as the non-empty string "false" and get dropped anyway.
          const isNonEmpty = (typeof val === 'boolean' || field.type === 'numberbox')
            ? false
            : (Array.isArray(val) ? val.length > 0 : (val !== undefined && val !== null && String(val).trim() !== ''));
          if (!includeFilled && isNonEmpty) return;
      
          // ensure unique key
          let finalKey = key;
          let i = 1;
          while (fields.hasOwnProperty(finalKey)) {
            finalKey = `${key}_${i++}`;
          }
      
          fields[finalKey] = {
            label: field.label || '',
            type: field.type || 'custom',
            value: field.value === undefined ? '' : field.value,
            options: field.options === undefined ? null : field.options,
           // meta: Object.assign({ name: meta.name || '', id: meta.id || '', selector: meta.selector || '', element: meta.element || null }, meta)
          };
        }
      
       

        // --- dynamic-table collection (dynamic-table controlType's nested dhs-editable-grid) ---
        // disabled for now (see ALLOWED_COMPONENTS) - not needed. Re-enable here plus the
        // matching applyAiDataToTemplateForm case and synthesizeDynamicTableConfig* methods
        // further down in this file, and the static-fallback branch in
        // v1-prescription.component.ts's setAIPreference(), to bring this back.
        /*
        const dynamicTableInputs = new Set<any>();
        root.find('app-dynamic-table dhs-editable-grid').each(function () {
          const $grid = $(this);
          if (!isReallyVisible($grid)) return;

          const $wrapper = $grid.closest('[id$="_ques"]');
          const wrapperId = $wrapper.attr('id') || '';
          const tableKey = wrapperId ? wrapperId.replace(/_ques$/, '') : '';
          if (!tableKey || exclude.includes(tableKey) || fields.hasOwnProperty(tableKey)) return;

          const columnLabels: { [key: string]: any } = {};
          const columnKeys: any[] = [];
          $grid.find('thead th[data-name]').each(function () {
            const $th = $(this);
            const colKey = $th.attr('data-name');
            if (colKey) {
              columnLabels[colKey] = $th.find('label').first().text().trim() || colKey;
              columnKeys.push(colKey);
            }
          });

          const rows: any[] = [];
          $grid.find('tbody tr').each(function () {
            const $row = $(this);
            const rowData: { [key: string]: any } = {};
            const $cells = $row.find('input, textarea, select');
            // Same row-header offset as the editgrid/edit_grid scan above.
            const keyOffset = Math.max(0, columnKeys.length - $cells.length);
            $cells.each(function (cellIndex) {
              const $cellEl = $(this);
              dynamicTableInputs.add(this);
              const colKey = columnKeys[cellIndex + keyOffset] || $cellEl.attr('id') || $cellEl.attr('name');
              if (!colKey) return;
              const v = $cellEl.val();
              rowData[colKey] = (v === undefined || v === null) ? '' : v;
            });
            if (Object.keys(rowData).length) rows.push(rowData);
          });

          // Always describe the table, even blank, so the AI knows the columns exist.
          fields[tableKey] = {
            label: getLabel($wrapper) || tableKey,
            type: 'dynamic-table',
            value: rows,
            options: Object.keys(columnLabels).length ? columnLabels : null
          };
        });
        */


        // --- radio-group collection (radio controlType, dynamic template questions) ---
        // These radio inputs have no shared `name` attribute (RadioControlValueAccessor
        // groups them via formControlName instead), so the name-based grouping below never
        // fires — group by the shared "<key>_ques" wrapper convention instead.
        const radioInputs = new Set();
        root.find('input[type="radio"]').each(function () {
          const $radio = $(this);
          if (!isReallyVisible($radio) || radioInputs.has(this)) return;

          const $wrapper = $radio.closest('[id$="_ques"]');
          const wrapperId = $wrapper.attr('id') || '';
          const radioKey = wrapperId ? wrapperId.replace(/_ques$/, '') : '';
          if (!radioKey || exclude.includes(radioKey) || fields.hasOwnProperty(radioKey)) return;

          const $group = $wrapper.find('input[type="radio"]').filter(function () {
            return isReallyVisible($(this));
          });
          if (!$group.length) return;

          const options: any[] = [];
          const values: any[] = [];
          $group.each(function () {
            const $ch = $(this);
            radioInputs.add(this);
            const optLabel = (function () {
              const idc = $ch.attr('id');
              if (idc) {
                const $lab = $(`label[for="${idc}"]`);
                if ($lab.length) return $lab.text().trim();
              }
              const $sibLabel = $ch.closest('label');
              if ($sibLabel.length) return $sibLabel.text().trim();
              return $ch.val();
            })();
            // A radio <input> here has no explicit [value] binding (see the comment above this
            // block) and so defaults to the literal string "on" for every option in the group —
            // that tells the AI nothing about which option is which, and invites it to echo that
            // meaningless "on" back as its answer (which then fails to match either option).
            // Fall back to the option's own label in that case, since it's what actually
            // distinguishes the options.
            const rawVal = $ch.val();
            const optValue = (rawVal == undefined || rawVal === '' || rawVal === 'on') ? optLabel : rawVal;
            options.push({ value: optValue, text: optLabel, selected: $ch.is(':checked') });
            if ($ch.is(':checked')) values.push(optValue);
          });

          const value = values.length ? values[0] : '';
          // Always describe this group regardless of includeFilled — a follow-up "change it
          // to No" needs the AI to see the current selection.
          //
          // The question's own label lives once per wrapper, separate from each option's own
          // wrapper label already captured above as its `text` — look it up the same way
          // rather than reusing getLabel() on the first option.
          const $groupLabel = $wrapper.find(`label[for="${radioKey}"]`);
          fields[radioKey] = {
            label: $groupLabel.length ? $groupLabel.first().text().trim() : (getLabel($wrapper) || radioKey),
            type: 'radio-group',
            value,
            options
          };
        });

        // --- checkbox-group collection (multi-option checkbox controlType) ---
        // Same gap as radio above (no shared `name`); group by "<key>_ques" wrapper. A lone
        // checkbox under a wrapper (question.options == undefined) is the simple boolean
        // shape and is left to the generic flat-field collection below.
        const checkboxInputs = new Set();
        root.find('input[type="checkbox"]').each(function () {
          const $cb = $(this);
          if (!isReallyVisible($cb) || checkboxInputs.has(this)) return;

          const $wrapper = $cb.closest('[id$="_ques"]');
          const wrapperId = $wrapper.attr('id') || '';
          const checkboxKey = wrapperId ? wrapperId.replace(/_ques$/, '') : '';
          if (!checkboxKey || exclude.includes(checkboxKey) || fields.hasOwnProperty(checkboxKey)) return;

          const $group = $wrapper.find('input[type="checkbox"]').filter(function () {
            return isReallyVisible($(this));
          });
          // A lone checkbox under this wrapper is the simple boolean shape, not a group —
          // leave it to the generic collector below.
          if ($group.length <= 1) return;

          const options: any[] = [];
          const values: any[] = [];
          $group.each(function () {
            const $ch = $(this);
            checkboxInputs.add(this);
            const optLabel = (function () {
              const idc = $ch.attr('id');
              if (idc) {
                const $lab = $(`label[for="${idc}"]`);
                if ($lab.length) return $lab.text().trim();
              }
              const $sibLabel = $ch.closest('label');
              if ($sibLabel.length) return $sibLabel.text().trim();
              return $ch.val();
            })();
            options.push({ value: $ch.val(), text: optLabel, selected: $ch.is(':checked') });
            if ($ch.is(':checked')) values.push($ch.val());
          });

          // Always describe this group (matching radio-group above) so a follow-up
          // "uncheck X and check Y" can see what's already checked.
          const $groupLabel = $wrapper.find(`label[for="${checkboxKey}"]`);
          fields[checkboxKey] = {
            label: $groupLabel.length ? $groupLabel.first().text().trim() : (getLabel($wrapper) || checkboxKey),
            type: 'checkbox-group',
            value: values,
            options
          };
        });

        // --- dropdown collection (dropdown controlType, dynamic template questions) ---
        // Options render via [ngValue], so Angular overwrites the DOM value attribute with
        // its own "<index>: <value>" tracking string, unusable for matching — describe/match
        // dropdowns by option TEXT instead, same as radio/checkbox groups' labels.
        const dropdownSelects = new Set();
        root.find('select').each(function () {
          const $select = $(this);
          if (!isReallyVisible($select) || dropdownSelects.has(this)) return;

          const $wrapper = $select.closest('[id$="_ques"]');
          const wrapperId = $wrapper.attr('id') || '';
          const dropdownKey = wrapperId ? wrapperId.replace(/_ques$/, '') : '';
          if (!dropdownKey || exclude.includes(dropdownKey) || fields.hasOwnProperty(dropdownKey)) return;

          dropdownSelects.add(this);

          const options: any[] = [];
          let selectedText = '';
          $select.find('option').each(function () {
            const $o = $(this);
            const text = $o.text().trim();
            const isSelected = $o.is(':selected');
            // Skip the blank "Select" placeholder — it isn't a real answer choice, and its own
            // text would otherwise be offered to the AI as if it were selectable.
            if (!text || text.toLowerCase() === 'select') return;
            options.push({ value: text, text: text, selected: isSelected });
            if (isSelected) selectedText = text;
          });
          
          const $groupLabel = $wrapper.find(`label[for="${dropdownKey}"]`);
          fields[dropdownKey] = {
            label: $groupLabel.length ? $groupLabel.first().text().trim() : (getLabel($wrapper) || dropdownKey),
            type: 'select',
            value: selectedText,
            options
          };
        });
      
        // --- main collection ---
        const inputs = root.find('input, textarea, select, [contenteditable="true"], [data-field-type], [data-field]');
      
        inputs.each(function () {
          const $el = $(this);
          if (!isReallyVisible($el)) return;
         // if (gridInputs.has(this)) return; // handled above as part of its grid's row data
         //if (scoreInputs.has(this)) return; // handled above as part of its score field's row data
         //if (dynamicTableInputs.has(this)) return; // handled above as part of its dynamic-table's rows - disabled, see collection block above
          if (radioInputs.has(this)) return; // handled above as part of its radio-group's options
          if (checkboxInputs.has(this)) return; // handled above as part of its checkbox-group's options
          if (dropdownSelects.has(this)) return; // handled above as part of its dropdown's options

          // custom handlers by selector or type:<name>
          let customUsed = false;
          for (const key in customHandlers) {
            try {
              if (key.indexOf('type:') === 0) {
                const dtype = key.split(':')[1];
                if ($el.attr('data-field-type') === dtype) {
                  const res = customHandlers[key]($el);
                  if (res) insertField(res);
                  customUsed = true;
                  break;
                }
              } else if ($el.is(key)) {
                const res = customHandlers[key]($el);
                if (res) insertField(res);
                customUsed = true;
                break;
              }
            } catch (e) {
              console.error('customHandler error for', key, e);
            }
          }
          if (customUsed) return;
      
          // if element declares data-field-type and there's a handler
          const dataFieldType = $el.attr('data-field-type');
          if (dataFieldType && customHandlers[`type:${dataFieldType}`]) {
            try {
              const res = customHandlers[`type:${dataFieldType}`]($el);
              if (res) insertField(res);
            } catch (e) {
              console.error('custom data-field-type handler error', e);
            }
            return;
          }
      
          const tagName = $el.prop('tagName').toLowerCase();
          const inputType = $el.attr('type') ? $el.attr('type').toLowerCase() : undefined;
          const type = normalizeType(tagName, inputType);
          const name = $el.attr('name') || '';
          const id = $el.attr('id') || '';
          const selector = (id ? `#${id}` : (name ? `[name="${name}"]` : $el.prop('tagName').toLowerCase()));
      
          // skip if name/id are explicitly excluded
          if (exclude.includes(name) || exclude.includes(id)) return;
      
          // handle grouped checkboxes / radios
          if ((type === 'radio' || type === 'checkbox') && name) {
            if (processedNames.has(name)) return;
            processedNames.add(name);
      
            const $group = root.find(`input[name="${name}"]`).filter(function () {
              return isReallyVisible($(this));
            });
            if (!$group.length) return;
      
            const options = [];
            const values = [];
            $group.each(function () {
              const $ch = $(this);
              const optLabel = (function () {
                const idc = $ch.attr('id');
                if (idc) {
                  const $lab = $(`label[for="${idc}"]`);
                  if ($lab.length) return $lab.text().trim();
                }
                const $sibLabel = $ch.closest('label');
                if ($sibLabel.length) return $sibLabel.text().trim();
                return $ch.val();
              })();
      
              // No explicit [value] binding defaults to the literal "on" for every option,
              // telling the AI nothing about which is which — fall back to the label instead.
              const rawVal = $ch.val();
              const optValue = (rawVal == undefined || rawVal === '' || rawVal === 'on') ? optLabel : rawVal;
      
              options.push({
                value: optValue,
                text: optLabel,
                selected: $ch.is(':checked')
              });
              if ($ch.is(':checked')) values.push(optValue);
            });
      
            // The question-level label is rendered once, separately from each option's own
            // wrapper label — prefer the exact label[for=name] match over $group.first()'s.
            const $groupLabel = root.find(`label[for="${name}"]`);
            const fieldObj = {
              label: $el.attr('data-field-label') || ($groupLabel.length ? $groupLabel.first().text().trim() : getLabel($group.first())),
              type: type === 'radio' ? 'radio-group' : 'checkbox-group',
              value: type === 'radio' ? (values.length ? values[0] : '') : values,
              options,
              meta: { name, id: id || '', selector, element: $group }
            };
      
            // if not including filled fields and there's a selected value, skip
            const isGroupFilled = type === 'radio' ? (fieldObj.value !== '') : (Array.isArray(fieldObj.value) && fieldObj.value.length > 0);
            if (!includeFilled && isGroupFilled) return;
      
            insertField(fieldObj);
            return;
          }
      
          // selects
          if (type === 'select') {
            const opts = getSelectOptions($el);
            const selectedVals = $el.val();
            const value = Array.isArray(selectedVals) ? selectedVals : (selectedVals === null ? '' : selectedVals);
      
            // skip if already has value (and includeFilled false)
            const hasVal = (Array.isArray(value) ? value.length > 0 : String(value) !== '');
            if (!includeFilled && hasVal) return;
      
            insertField({
              label: $el.attr('data-field-label') || getLabel($el),
              type: $el.prop('multiple') ? 'select-multiple' : 'select',
              value: value,
              options: opts,
              meta: { name, id, selector, element: $el }
            });
            return;
          }
      
          // contenteditable
          if ($el.is('[contenteditable="true"]')) {
            // CKEditor's editable div has no name/id of its own — the real question.key
            // lives on the <ckeditor> host element; walk up to it or makeKeyFromParts falls
            // back to a garbage slugified key that never matches the real control.
            const $ckHost = $el.closest('ckeditor');
            if ($ckHost.length) {
              const ckId = $ckHost.attr('id') || '';
              const v = getCkEditableValue($el);
              const ckLabel = $el.attr('data-field-label') || getLabel($ckHost);
              const ckKey = makeKeyFromParts(ckId, ckId, ckLabel);
              //  describe this field (matching the collectors above) so a follow-up
              // "add a row to that table" has the current content to amend.
              if (ckKey && !exclude.includes(ckKey) && !fields.hasOwnProperty(ckKey)) {
                fields[ckKey] = { label: ckLabel, type: 'html-editor', value: v, options: null };
              }
              return;
            }
            const v = $el.text().trim();
            if (!includeFilled && v !== '') return;
            insertField({
              label: $el.attr('data-field-label') || getLabel($el),
              type: 'contenteditable',
              value: v,
              options: null,
              meta: { name, id, selector, element: $el }
            });
            return;
          }
      
          // textarea
          if (type === 'textarea') {
            const v = $el.val();
            if (!includeFilled && v !== undefined && String(v).trim() !== '') return;
            insertField({
              label: $el.attr('data-field-label') || getLabel($el),
              type: 'textarea',
              value: v === undefined ? '' : v,
              options: null,
              meta: { name, id, selector, element: $el }
            });
            return;
          }
      
          // input
          if (tagName === 'input') {
            // file input
            if (inputType === 'file') {
              const files = $el[0].files;
              const farr = [];
              if (files && files.length) {
                for (let i = 0; i < files.length; i++) farr.push(files[i].name);
              }
              if (!includeFilled && farr.length > 0) return;
              insertField({
                label: $el.attr('data-field-label') || getLabel($el),
                type: 'file',
                value: farr,
                options: null,
                meta: { name, id, selector, element: $el }
              });
              return;
            }

            // simple (ungrouped) checkbox — the plain boolean shape from checkbox.component.html.
            // Its [value]="value" binding mirrors the checked state as the string "true"/"false"
            // (never empty), which would make the generic "already filled" gate below wrongly
            // treat it as pre-filled — always describe it instead (matching the group collectors
            // above), so a follow-up "uncheck it" has something to act on.
            if (inputType === 'checkbox') {
              insertField({
                label: $el.attr('data-field-label') || getLabel($el),
                type: 'checkbox',
                value: $el.is(':checked'),
                options: null,
                meta: { name, id, selector, element: $el }
              });
              return;
            }

            // numberbox — same "always describe" reasoning as checkbox above, so a
            // follow-up "change it to X" has something to act on.
            if (inputType === 'number') {
              const numVal = $el.val();
              insertField({
                label: $el.attr('data-field-label') || getLabel($el),
                type: 'numberbox',
                value: numVal === undefined ? '' : numVal,
                options: null,
                meta: { name, id, selector, element: $el }
              });
              return;
            }
      
            // default input types
            const val = $el.val();
            if (!includeFilled && val !== undefined && String(val).trim() !== '') return;
      
            insertField({
              label: $el.attr('data-field-label') || getLabel($el),
              type: normalizeType('input', inputType),
              value: val === undefined ? '' : val,
              options: null,
              meta: { name, id, selector, element: $el }
            });
            return;
          }
      
          // fallback custom elements
          const fallbackVal = (function () {
            try {
              if ($el.is('img')) return $el.attr('src');
              if ($el.is('a')) return $el.attr('href');
              if (typeof $el.val === 'function' && $el.val() !== undefined) return $el.val();
              return $el.text().trim();
            } catch (e) {
              return '';
            }
          })();
          if (!includeFilled && fallbackVal !== '') return;
      
          insertField({
            label: $el.attr('data-field-label') || getLabel($el),
            type: 'custom',
            value: fallbackVal,
            options: null,
            meta: { name, id, selector, element: $el }
          });
        });
      
        // Page-wide supplementary sweep for <ckeditor id="question.key"> — sidesteps the
        // root-scoping mismatch above when the field lives in a form `root` doesn't cover.
        $('ckeditor[id]').each(function () {
          const $ck = $(this);
          const key = $ck.attr('id');
          if (!key || exclude.includes(key) || fields.hasOwnProperty(key)) return;
          if (!isReallyVisible($ck)) return;
          const $editable = $ck.find('[contenteditable="true"]').first();
          const v = $editable.length ? getCkEditableValue($editable) : '';
          fields[key] = { label: getLabel($ck) || key, type: 'html-editor', value: v, options: null };
        });
      
        if (typeof callback === 'function') callback(fields);
        return fields;
      }
      
      parseLLMJsonResponse(raw: string): any | null {
        if (!raw || typeof raw !== "string") return null;
      
        try {
          let cleaned = raw.trim();
      
          // 1. Remove markdown fences ONLY (allowed)
          cleaned = cleaned
            .replace(/^```json\s*/i, "")
            .replace(/^```/, "")
            .replace(/```$/, "")
            .trim();
      
          // 2. Basic sanity check → must start with { or [
          if (!/^[\[{]/.test(cleaned)) {
            console.error("❌ Not a pure JSON response");
            return raw;
          }
      
          // 3. Fix minimal safe issues
          cleaned = this.fixJsonSafely(cleaned);
      
          // 4. Parse
          return JSON.parse(cleaned);
      
        } catch (err1) {
          try {
            // 5. Handle double-encoded JSON
            const parsed = JSON.parse(raw);
            if (typeof parsed === "string") {
              return JSON.parse(parsed);
            }
            return parsed;
          } catch (err2) {
            console.error("❌ Failed to parse LLM JSON:", {
              original: raw,
              err1,
              err2
            });
            return raw;
          }
        }
      }
      
      /**
       * Only SAFE fixes (no aggressive guessing)
       */
      fixJsonSafely(json: string): string {
        let fixed = json;
      
        // Remove trailing commas
        fixed = fixed.replace(/,\s*([}\]])/g, "$1");
      
        // Remove control characters
        fixed = fixed.replace(/[\u0000-\u001F]+/g, "");

        return fixed;
      }

    //Moved from kx-ai-speech.component.ts - the AI sometimes nests answers under an invented
    //section wrapper (e.g. {socialHistory:{type:"object",fields:{smoke:{...}}}}) instead of flat
    //top-level keys, invisible to applyAiDataToTemplateForm()'s flat templateData[ctrl] lookup.
    //Re-home each leaf onto its real control key by matching label text, not the AI's invented
    //key names. Run this on raw AI data before applyAiDataToTemplateForm().
    normalizeAiResponse(rawData: any, formGroup: any): any {
        if (!rawData || typeof rawData != 'object' || formGroup?.controls == undefined) {
            return rawData;
        }
        const normalizeLabel = (s: any) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

        const labelToKey: { [key: string]: string } = {};
        for (let ctrl in formGroup.controls) {
            let question = (formGroup.controls[ctrl] as any)?.question_component?.question;
            if (question?.label) {
                labelToKey[normalizeLabel(question.label)] = ctrl;
            }
        }

        const flat: any = { ...rawData };
        const walk = (node: any) => {
            if (!node || typeof node != 'object') return;
            if (node.type == 'object' && node.fields) {
                let children = Array.isArray(node.fields) ? node.fields : Object.values(node.fields);
                children.forEach((child: any) => walk(child));
                return;
            }
            if (node.label != undefined) {
                let key = labelToKey[normalizeLabel(node.label)];
                if (key && flat[key] == undefined) {
                    flat[key] = node;
                }
            }
        };
        for (let key in rawData) {
            let value = rawData[key];
            if (value && typeof value == 'object' && value.type == 'object' && value.fields) {
                walk(value);
                delete flat[key];
            }
        }
        return flat;
    }

    
    //Shared with kx-ai-speech.component.ts's own fillData()/setOptionValue()/setRadioValue()/
    //setCheckboxGroupValue() switch - same per-controlType matching logic, extracted from
    //v1-prescription.component.ts so both callers apply an AI response to form controls the
    //same way instead of maintaining parallel copies.
    applyAiDataToTemplateForm(formGroup: any, templateData: any, compositeFormMapping?: any, onNotFound?: (questionComponent: any, formControl: any) => void) {
        if (!formGroup || !formGroup.controls) return;
        if (typeof templateData === 'string') {
            //Single free-text answer with no field-key structure - apply it to the block's first
            //textarea control, matching the old single-field behavior.
            for (let ctrl in formGroup.controls) {
                const formControl: any = formGroup.controls[ctrl];
                const question = formControl.question_component?.question;
                if (question?.controlType === 'textarea') {
                    formControl.setValue(templateData);
                    formControl.updateValueAndValidity();
                    formControl.question_component.valueChange({ value: templateData, target: { value: templateData } }, question);
                    break;
                }
            }
            return;
        }
        if (typeof templateData !== 'object' || templateData === null) return;
        for (let ctrl in formGroup.controls) {
            if (templateData[ctrl] === undefined) continue;
            const formControl: any = formGroup.controls[ctrl];
            const questionComponent = formControl.question_component;
            const question = questionComponent?.question;
            if (!question) continue;
            //Matches kx-ai-speech.component.ts's fillData(), which skips any control type not on
            //this allowlist entirely rather than falling through to a generic setValue().
            if (this.ALLOWED_COMPONENTS.indexOf(question.controlType) == -1) continue;
            const questionValue = (templateData[ctrl]?.value !== undefined) ? templateData[ctrl].value : templateData[ctrl];
            switch (question.controlType) {
                case 'composite-array': {
                    //Recurses into itself per row - compositeFormMapping[key] is already shaped
                    //like a formGroup (has .controls), matching kx-ai-speech.component.ts's
                    //fillData() composite-array case, which this is adapted from.
                    const questionKey = question.key;
                    const rowData = templateData[questionKey];
                    const nestedFormGroup = compositeFormMapping?.[questionKey];
                    if (Array.isArray(rowData) && rowData.length > 0 && nestedFormGroup != undefined) {
                        rowData.forEach((rawElement: any) => {
                            this.applyAiDataToTemplateForm(nestedFormGroup, rawElement, compositeFormMapping, onNotFound);
                        });
                    }
                    break;
                }
                case 'dropdown':
                    if (questionValue && questionValue != '') {
                        this.setTemplateOptionValue(questionValue, questionComponent, formControl, onNotFound ? () => onNotFound(questionComponent, formControl) : undefined);
                    }
                    break;
                case 'radio': {
                    //AI sometimes echoes the schema's placeholder value ("on") back unchanged
                    //while still marking the right choice via `selected` - fall back to that,
                    //matching kx-ai-speech.component.ts's fillData() radio case.
                    let radioAnswer = questionValue;
                    if ((radioAnswer === undefined || radioAnswer === null || radioAnswer === '' || radioAnswer === 'on') && Array.isArray(templateData[ctrl]?.options)) {
                        const selectedOption = templateData[ctrl].options.find((opt: any) => opt?.selected === true);
                        if (selectedOption) {
                            radioAnswer = selectedOption.text !== undefined ? selectedOption.text : selectedOption.value;
                        }
                    }
                    if (radioAnswer !== undefined && radioAnswer !== null && radioAnswer !== '') {
                        this.setTemplateRadioValue(radioAnswer, questionComponent, formControl, onNotFound ? () => onNotFound(questionComponent, formControl) : undefined);
                    }
                    break;
                }
                case 'single-choice-question':
                    if (questionValue !== undefined && questionValue !== null && questionValue !== '') {
                        this.setTemplateRadioValue(questionValue, questionComponent, formControl, onNotFound ? () => onNotFound(questionComponent, formControl) : undefined);
                    }
                    break;
                case 'checkbox':
                    if (questionValue !== undefined && questionValue !== null && questionValue !== '') {
                        if (Array.isArray(question.options) && question.options.length > 0) {
                            this.setTemplateCheckboxGroupValue(questionValue, questionComponent, formControl, onNotFound ? () => onNotFound(questionComponent, formControl) : undefined);
                        } else {
                            let parsedValue: any = questionValue;
                            if (question.type !== 'String' && question.type !== 'text' && question.type !== 'array') {
                                parsedValue = this.parseTemplateAiCheckboxValue(questionValue);
                            }
                            formControl.setValue(parsedValue);
                            formControl.updateValueAndValidity();
                            questionComponent.valueChange({ target: { checked: parsedValue, value: parsedValue } }, question);
                        }
                    }
                    break;
                case 'daterangepicker':
                    if (questionValue && questionValue != '') {
                        const parsedDate = this.parseTemplateAiDateValue(questionValue, question);
                        if (parsedDate != null) {
                            formControl.setValue(parsedDate);
                            formControl.updateValueAndValidity();
                            questionComponent.valueChange({ value: parsedDate, target: { value: parsedDate } }, question);
                            //Range mode: valueChange()'s getDataOnDateChange() does `new Date(event)` on the
                            //{value,target} wrapper above, which isn't date-parseable and can leave the control
                            //holding a garbled value - re-assert the already-correct parsedDate.
                            if (!question.singleDatePicker) {
                                formControl.setValue(parsedDate);
                                formControl.updateValueAndValidity();
                            }
                        }
                    }
                    break;
                case 'html-editor':
                    if (questionValue && questionValue != '') {
                        const htmlValue = String(questionValue).split('\n').join('<br/>');
                        const safeValue = this.sanitizer.sanitize(SecurityContext.HTML, htmlValue) || '';
                        formControl.setValue(safeValue);
                        formControl.updateValueAndValidity();
                        questionComponent.valueChange(safeValue, question);
                    }
                    break;
                case 'searchselect':
                    //Not handled here - kx-ai-speech.component.ts's fillData() also skips searchselect.
                    break;
                //dynamic-table AI-fill disabled for now, not needed - see ALLOWED_COMPONENTS
                //and synthesizeDynamicTableConfig* above. Re-enable this whole case together
                //with those to bring it back.
                /*
                case 'dynamic-table': {
                    //dynamic-table's value is a single JSON-stringified {tableVal, tableConfig}
                    //blob, not real per-row FormGroups like composite-array. A predefined table
                    //never writes one until the user edits a row, so on its first-ever fill
                    //synthesizeDynamicTableConfig() builds one from question.tabular_list instead
                    //(see its own comment for what it can/can't reconstruct).
                    if (!Array.isArray(questionValue) || questionValue.length === 0) break;
                    const currentRaw = formControl.value;
                    const synthesized = currentRaw ? null : this.synthesizeDynamicTableConfig(question, ctrl);
                    if (!currentRaw && !synthesized) break;
                    try {
                        const parsedTable = currentRaw ? JSON.parse(currentRaw) : synthesized;
                        //Merge into existing rows by column key rather than replacing tableVal
                        //wholesale - caps to the rows that already exist (any extra rows the AI
                        //returns beyond that are ignored, so a fill can never add/remove rows),
                        //and only touches columns the AI actually answered, so an untouched cell
                        //keeps its prior value instead of being wiped by a partial answer.
                        const existingRows: any[] = Array.isArray(parsedTable.tableVal) ? parsedTable.tableVal : [];
                        existingRows.forEach((row: any, i: number) => {
                            const aiRow = questionValue[i];
                            if (aiRow && typeof aiRow === 'object') {
                                Object.keys(aiRow).forEach(colKey => {
                                    if (aiRow[colKey] !== undefined && aiRow[colKey] !== null && aiRow[colKey] !== '') {
                                        //Cells are text-type inputs, so a manually-typed value is
                                        //always a string - the AI's JSON answer can come back as a
                                        //number (e.g. 1 instead of "1"), which the frontend renders
                                        //fine either way but the backend print template appears to
                                        //require a string for, so coerce to match what a real user
                                        //typing into the cell would always produce.
                                        row[colKey] = String(aiRow[colKey]);
                                    }
                                });
                            }
                        });
                        parsedTable.tableVal = existingRows;
                        const newRaw = JSON.stringify(parsedTable);
                        //Transient marker so DynamicTableComponent.writeValue() (triggered
                        //synchronously by setValue() below) knows this specific update is
                        //AI-driven and should reparse/re-render - cleared right after so it
                        //doesn't linger and affect some later, unrelated setValue() call.
                        question['_ai_filling'] = true;
                        formControl.setValue(newRaw);
                        formControl.updateValueAndValidity();
                        question['_ai_filling'] = false;
                        questionComponent.valueChange({ value: newRaw, target: { value: newRaw } }, question);
                    } catch (e) {
                        //Existing value isn't valid JSON - nothing safe to merge into.
                        question['_ai_filling'] = false;
                    }
                    break;
                }
                */
                default:
                    if (questionValue && questionValue != '') {
                        formControl.setValue(questionValue);
                        formControl.markAsTouched();
                        formControl.markAsDirty();
                        formControl.updateValueAndValidity();
                        questionComponent.valueChange({ value: questionValue, target: { value: questionValue } }, question);
                    }
                    break;
            }
        }
    }

    //Adapted from kx-ai-speech.component.ts's setOptionValue() (dropdown), setRadioValue() and
    //setCheckboxGroupValue() - same matching logic. onNotFound is optional so callers with a
    //review-list UI (e.g. kx-ai-speech.component.ts's dialogConfig.data.notFound) can hook into
    //an unmatched answer; callers without one (e.g. v1-prescription.component.ts) just omit it.
    setTemplateOptionValue(value: any, questionComponent: any, formControl: any, onNotFound?: () => void) {
        const question = questionComponent.question;
        if (!Array.isArray(question.options) || question.options.length == 0) return;
        const normalizedAnswer = String(value).trim().toLowerCase();
        let matchedElement: any = undefined;
        for (let i = 0; i < question.options.length && !matchedElement; i++) {
            const element = question.options[i];
            if (element[question.getterKey] == undefined || element[question.getterValue] == undefined) continue;
            const optKey = String(element[question.getterKey]).trim().toLowerCase();
            const optText = String(element[question.getterValue]).trim().toLowerCase();
            if (optText == normalizedAnswer || optKey == normalizedAnswer) {
                matchedElement = element;
            }
        }
        if (!matchedElement) {
            let bestMatchLength = -1;
            for (let i = 0; i < question.options.length; i++) {
                const element = question.options[i];
                if (element[question.getterValue] == undefined) continue;
                const optText = String(element[question.getterValue]).trim().toLowerCase();
                if ((normalizedAnswer.endsWith(': ' + optText) || normalizedAnswer.includes(optText)) && optText.length > bestMatchLength) {
                    matchedElement = element;
                    bestMatchLength = optText.length;
                }
            }
        }
        if (matchedElement) {
            const rawValue = matchedElement[question.getterKey];
            formControl.setValue(rawValue);
            formControl.updateValueAndValidity();
            questionComponent.valueChange({ value: rawValue, target: { value: rawValue, selectedIndex: question.options.indexOf(matchedElement) + 1 } }, question);
        } else if (onNotFound) {
            onNotFound();
        }
    }

    setTemplateRadioValue(value: any, questionComponent: any, formControl: any, onNotFound?: () => void) {
        const question = questionComponent.question;
        const getterKey = question.getterKey || 'id';
        const getterValue = question.getterValue || 'value';
        if (Array.isArray(question.options) && question.options.length > 0) {
            const normalizedAnswer = (typeof value == 'boolean') ? (value ? 'yes' : 'no') : String(value).trim().toLowerCase();
            for (let i = 0; i < question.options.length; i++) {
                const element = question.options[i];
                const optKey = element[getterKey];
                const optText = element[getterValue];
                if (optKey == undefined) continue;
                if (String(optKey).trim().toLowerCase() == normalizedAnswer || (optText != undefined && String(optText).trim().toLowerCase() == normalizedAnswer)) {
                    formControl.setValue(optKey);
                    formControl.updateValueAndValidity();
                    questionComponent.valueChange({ value: optKey, target: { id: optKey, value: optKey, selectedIndex: i + 1 } }, question);
                    return;
                }
            }
        }
        if (onNotFound) {
            onNotFound();
        }
    }

    setTemplateCheckboxGroupValue(value: any, questionComponent: any, formControl: any, onNotFound?: () => void) {
        const question = questionComponent.question;
        const getterKey = question.getterKey || 'id';
        const getterValue = question.getterValue || 'value';
        const answers = Array.isArray(value) ? value : [value];
        const selectedKeys: any[] = [];
        let hasUnmatchedAnswer = false;
        if (Array.isArray(question.options) && question.options.length > 0) {
            answers.forEach((answer) => {
                if (answer == undefined || answer === '' || answer === false) return;
                const normalizedAnswer = (typeof answer == 'boolean') ? 'yes' : String(answer).trim().toLowerCase();
                let matched = false;
                for (let i = 0; i < question.options.length; i++) {
                    const element = question.options[i];
                    const optKey = element[getterKey];
                    const optText = element[getterValue];
                    if (optKey == undefined) continue;
                    if (String(optKey).trim().toLowerCase() == normalizedAnswer || (optText != undefined && String(optText).trim().toLowerCase() == normalizedAnswer)) {
                        if (selectedKeys.indexOf(optKey) == -1) {
                            selectedKeys.push(optKey);
                        }
                        matched = true;
                        break;
                    }
                }
                if (!matched) {
                    hasUnmatchedAnswer = true;
                }
            });
        }
        //An AI answer of [] (e.g. "uncheck diabetes") is a deliberate clear, not a matching
        //failure - only apply when there's a real match or a genuine clear; otherwise leave the
        //control untouched instead of wiping it to an empty selection. Matches
        //kx-ai-speech.component.ts's setCheckboxGroupValue().
        if (selectedKeys.length > 0 || !hasUnmatchedAnswer) {
            //dhs-checkbox's own onSelect() (checkbox.component.ts) branches on question.type:
            //'String' means single-select - clicking a box replaces the whole value with that
            //one option's key directly (a plain string), never an array. Anything else
            //accumulates into a real array, and its own writeValue()/value setter only parses a
            //JSON-stringified string into that array for type:'array' specifically - fed a raw
            //array directly, that parse branch never fires and the value round-trips
            //differently than a manually-checked box. Match both contracts exactly.
            const type = typeof question.type === 'string' ? question.type.toLowerCase() : '';
            const isStringType = type === 'string';
            const isArrayType = type === 'array';
            const valueToSet = isStringType
                ? (selectedKeys.length > 0 ? selectedKeys[selectedKeys.length - 1] : '')
                : (isArrayType ? JSON.stringify(selectedKeys) : selectedKeys);
            formControl.setValue(valueToSet);
            formControl.updateValueAndValidity();
            questionComponent.valueChange({ value: isStringType ? valueToSet : selectedKeys, options: true }, question);
        } else if (onNotFound) {
            onNotFound();
        }
    }

    parseTemplateAiCheckboxValue(rawValue: any) {
        if (typeof rawValue == 'boolean') return rawValue;
        const normalized = String(rawValue).trim().toLowerCase();
        const negativeValues = ['false', 'no', '0', 'n', 'unchecked'];
        return negativeValues.indexOf(normalized) == -1;
    }

    parseTemplateAiDateValue(rawValue: any, question: any) {
        const useCurrentTime = question.timePicker === true;
        const hasExplicitTime = (str: any) => /\d{1,2}\s*(am|pm)\b/i.test(str) || /\b([01]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?\b/.test(str);
        const cleanToTimestamp = (str: any) => {
            const cleaned = String(str).trim().replace(/(\d+)(st|nd|rd|th)\b/gi, '$1');
            const parsedDate = new Date(cleaned);
            if (isNaN(parsedDate.getTime())) return null;
            if (useCurrentTime && !hasExplicitTime(cleaned)) {
                const now = new Date();
                const isToday = parsedDate.getFullYear() == now.getFullYear() && parsedDate.getMonth() == now.getMonth() && parsedDate.getDate() == now.getDate();
                if (isToday) {
                    parsedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
                } else {
                    parsedDate.setHours(0, 0, 0, 0);
                }
            }
            return parsedDate.getTime();
        };
        if (question.singleDatePicker) {
            return cleanToTimestamp(rawValue);
        } else {
            const parts = String(rawValue).split(/\s+to\s+/i);
            if (parts.length == 2) {
                const startTimestamp = cleanToTimestamp(parts[0]);
                const endTimestamp = cleanToTimestamp(parts[1]);
                if (startTimestamp != null && endTimestamp != null) {
                    const startKey = question.startKey || 'startDate';
                    const endKey = question.endKey || 'endDate';
                    return { [startKey]: startTimestamp, [endKey]: endTimestamp };
                }
            }
            return null;
        }
    }      
    //Dynamic-table AI-fill disabled for now, not needed - see ALLOWED_COMPONENTS. These three
    //methods synthesize a {tableVal, tableConfig} blob for a never-touched predefined table so
    //applyAiDataToTemplateForm's (also disabled) dynamic-table case has something to merge AI
    //rows into. Re-enable together with that case and collectVisibleFields' dynamic-table
    //collection block above.
    /*
    synthesizeDynamicTableConfig(question: any, ctrl: string): any {
        return this.synthesizeDynamicTableConfigFromTabularList(question) || this.synthesizeDynamicTableConfigFromDom(ctrl);
    }

    synthesizeDynamicTableConfigFromTabularList(question: any): any {
        const tabular_list = question?.tabular_list;
        if (!tabular_list) return null;
        const field = JSON.parse(JSON.stringify(tabular_list));

        const is_rowHeader = field.is_rowHeader != undefined ? field.is_rowHeader : false;
        const items = is_rowHeader
            ? (field.rowHeader || []).map((obj: any) => ({ rowheader: obj.title }))
            : Array.from({ length: field.rowHeader != undefined ? field.rowHeader : (field.no_of_rows || 0) }, () => ({}));

        if (is_rowHeader) {
            const row_header_title = (field?.row_header_title != null && field.row_header_title !== '') ? field.row_header_title : "field.val.empty";
            field.fields.unshift({ label: row_header_title, name: "rowheader", component: "label", type: "string", order: 0 });
        }

        const json: any = { list: { fields: field.fields, rowHeader: field.rowHeader } };
        if (field.row_type === 'dynamic') {
            json.list.actions = [{
                conditions: [
                    { "copy": field, "expression": "true" },
                    { "delete": true, "expression": "true" },
                    { "add": true, "expression": "true" }
                ]
            }];
        }

        return {
            tableVal: items,
            tableConfig: {
                is_rowHeader,
                json,
                config: { items, search: false, last_row_add: true, questionKey: question.key || '' }
            }
        };
    }

    synthesizeDynamicTableConfigFromDom(ctrl: string): any {
        const $wrapper = $(`[id="${ctrl}_ques"]`);
        const $grid = $wrapper.find('dhs-editable-grid').first();
        if (!$grid.length) return null;

        const columnLabels: { [key: string]: any } = {};
        const columnKeys: any[] = [];
        const columnComponents: { [key: string]: string } = {};
        $grid.find('thead th[data-name]').each(function () {
            const $th = $(this);
            const colKey = $th.attr('data-name');
            if (colKey) {
                columnLabels[colKey] = $th.find('label').first().text().trim() || colKey;
                columnKeys.push(colKey);
            }
        });

        const rows: any[] = [];
        $grid.find('tbody tr').each(function () {
            const $row = $(this);
            const rowData: { [key: string]: any } = {};
            const $cells = $row.find('input, textarea, select');
            const keyOffset = Math.max(0, columnKeys.length - $cells.length);
            $cells.each(function (cellIndex) {
                const $cellEl = $(this);
                const colKey = columnKeys[cellIndex + keyOffset] || $cellEl.attr('id') || $cellEl.attr('name');
                if (!colKey) return;
                if (!columnComponents[colKey]) {
                    const tag = (this as HTMLElement).tagName.toLowerCase();
                    columnComponents[colKey] = tag === 'select' ? 'dropdown' : tag === 'textarea' ? 'textarea' : 'textbox';
                }
                const v = $cellEl.val();
                rowData[colKey] = (v === undefined || v === null) ? '' : v;
            });
            if (Object.keys(rowData).length) rows.push(rowData);
        });
        if (!columnKeys.length) return null;

        const tableConfig = {
            is_rowHeader: false,
            json: {
                list: {
                    fields: columnKeys.map(colKey => ({
                        label: columnLabels[colKey],
                        name: colKey,
                        component: columnComponents[colKey] || 'textbox'
                    }))
                }
            },
            config: {
                items: rows,
                search: false,
                last_row_add: true,
                questionKey: ctrl
            }
        };
        return { tableVal: rows, tableConfig };
    }
    */
    
}